import { StructuralLayerFunctionType } from "./structural-layer-function-type";


export type StructuralLayerFunction = {
  type: StructuralLayerFunctionType;
  hierarchy: number;
  function: string;
};

const _structuralLayerFunctionMapper = new Map<
  StructuralLayerFunctionType,
  StructuralLayerFunction
>();

const structure: StructuralLayerFunction = {
  type: 'STRUCTURE',
  hierarchy: 1,
  function: 'Structure',
};

const substrate: StructuralLayerFunction = {
  type: 'SUBSTRATE',
  hierarchy: 2,
  function: 'Substrate',
};

const thermal: StructuralLayerFunction = {
  type: 'THERMAL_AIR',
  hierarchy: 3,
  function: 'Thermal/Air layer',
};

const finish1: StructuralLayerFunction = {
  type: 'FINISH1',
  hierarchy: 4,
  function: 'Finish 1',
};

const finish2: StructuralLayerFunction = {
  type: 'FINISH2',
  hierarchy: 5,
  function: 'Finish 2',
};

const membrane: StructuralLayerFunction = {
  type: 'MEMBRANE',
  hierarchy: 6,
  function: 'Membrane layer',
};

_structuralLayerFunctionMapper.set('STRUCTURE', structure);
_structuralLayerFunctionMapper.set('SUBSTRATE', substrate);
_structuralLayerFunctionMapper.set('THERMAL_AIR', thermal);
_structuralLayerFunctionMapper.set('FINISH1', finish1);
_structuralLayerFunctionMapper.set('FINISH2', finish2);
_structuralLayerFunctionMapper.set('MEMBRANE', membrane);

export const structuralLayerFunctionMapper = _structuralLayerFunctionMapper;
export const structuralLayerFunctionData = Array.from(
  _structuralLayerFunctionMapper.values()
);
